// @dynamic
export default class Utils {
    /** This returns a range of numbers. Starts from 0 if 'startFrom' is not set */
    public static getRange(startFrom: number, until: number) {
        return Array.from({ length: until + 1 - startFrom }, (_, k) => k + startFrom);
    }

    public static isSingleTimeCron = (cron: string) => {
        const parts = cron.trim().split(/\s+/);
        if (parts.length !== 7) return false; // Quartz style only

        const [sec, min, hour, day, month, dow, year] = parts;

        const isFixed = v => /^\d+$/.test(v); // pure number only

        // must have specific values for each date/time part
        return (
            isFixed(sec) && isFixed(min) && isFixed(hour) && isFixed(day) && isFixed(month) && (dow === '?' || dow === '*') && isFixed(year)
        );
    };
}
